// ==============================|| OVERRIDES - AUTOCOMPLETE ||============================== //

import { Components, inputBaseClasses, Theme } from "@mui/material"

export default function Autocomplete(): Components<Omit<Theme, "components">> {
    return {
        MuiAutocomplete: {
            styleOverrides: {
                root: {
                    "& .MuiOutlinedInput-root": {
                        padding: "3px 9px",
                        minHeight: 48,
                    },
                    [`& .${inputBaseClasses.sizeSmall}.MuiOutlinedInput-root`]: {
                        padding: "3px 9px",
                        minHeight: 37,
                    },
                },
                popupIndicator: {
                    width: "auto",
                    height: "auto",
                },
                clearIndicator: {
                    width: "auto",
                    height: "auto",
                },
            },
        },
    }
}
